<template>
    <div class="connectors-box">
        <a class="btn btn-simple btn-block btn-connect"
            v-if="services.google"
            :href="services.google">
          <svg class="icon-connect" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.64 9.20443C17.64 8.56625 17.5827 7.95262 17.4764 7.36353H9V10.8449H13.8436C13.635 11.9699 13.0009 12.9231 12.0477 13.5613V15.8194H14.9564C16.6582 14.2526 17.64 11.9453 17.64 9.20443Z" fill="#4285F4"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99976 18C11.4298 18 13.467 17.1941 14.9561 15.8195L12.0475 13.5613C11.2416 14.1013 10.2107 14.4204 8.99976 14.4204C6.65567 14.4204 4.67158 12.8372 3.96385 10.71H0.957031V13.0418C2.43794 15.9831 5.48158 18 8.99976 18Z" fill="#34A853"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.96409 10.7101C3.78409 10.1701 3.68182 9.59325 3.68182 9.00007C3.68182 8.40689 3.78409 7.83007 3.96409 7.29007V4.95825H0.957273C0.347727 6.17325 0 7.5478 0 9.00007C0 10.4523 0.347727 11.8269 0.957273 13.0419L3.96409 10.7101Z" fill="#FBBC05"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99976 3.57955C10.3211 3.57955 11.5075 4.03364 12.4402 4.92545L15.0216 2.34409C13.4629 0.891818 11.4257 0 8.99976 0C5.48158 0 2.43794 2.01682 0.957031 4.95818L3.96385 7.29C4.67158 5.16273 6.65567 3.57955 8.99976 3.57955Z" fill="#EA4335"></path>
          </svg>
          {{ __('trads.Continue-with-Google') }}
        </a>

        <a class="btn btn-simple btn-block btn-connect"
            v-if="services.facebook"
            :href="services.facebook">
          <svg class="icon-connect" width="18" height="18" viewBox="0 0 14222 14222">
            <circle cx="7111" cy="7112" r="7111" fill="#1977f3" />
            <path d="M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z" fill="#fff" />
          </svg>
          {{ __('trads.Continue-with-Facebook') }}
        </a>

        <a class="btn btn-simple btn-block btn-connect"
            v-if="services.apple"
            :href="services.apple">
              <svg class="icon-connect icon-apple" width="18" height="18" viewBox="0 -1 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 14.673C15.3712 16.573 13.4888 19.9373 11.5496 19.974C10.2632 19.9998 9.8496 19.1798 8.3792 19.1798C6.9096 19.1798 6.4496 19.949 5.2336 19.999C3.176 20.0815 0 15.143 0 10.8362C0 6.88022 2.6464 4.91933 4.9584 4.88349C6.1984 4.86016 7.3696 5.75435 8.1256 5.75435C8.8848 5.75435 10.3072 4.67932 11.8024 4.83682C12.428 4.86432 14.1856 5.09933 15.3136 6.81772C12.3208 8.85279 12.7872 13.1088 16 14.673ZM11.8224 0C9.5616 0.0950031 7.7168 2.56592 7.9744 4.60932C10.064 4.77849 12.0688 2.33841 11.8224 0Z" fill="white"></path></svg></i>
              {{ __('trads.Continue-with-Apple') }}
        </a>
    </div>
</template>

<script>
export default {
  name: "Connectors",
  props: [
    'enabled'
  ],
  data() {
    return {
        services: {},
    }
  },
  beforeMount() {
    for (const [name, url] of Object.entries(this.enabled)) {
        console.log(`${name}: ${url}`);
        this.services[name] = url;
    }
  },
}
</script>
